import { useState } from 'react';
import { Link } from 'react-router';
import { api, errorMessage } from '../../shared/api/client';
import type { FinanceOverview } from '../../shared/api/types';
import { Alert, Button, Card } from '../../shared/ui/components';
import { useAsync } from '../../shared/ui/useAsync';
import { formatMoney } from './money';

/** Trabajos de mantenimiento terminados cuyo costo aún no se registra: Finanzas elige la cuenta y lo registra. */
export function MaintenancePendingCard({ churchId, overview, onChange }: { churchId: string; overview: FinanceOverview; onChange: (m?: string) => void }) {
  const base = `/inventory/churches/${churchId}/maintenance`;
  const data = useAsync((signal) => api.get<{ items: { id: string; title: string; actualCostCents: number }[] }>(`${base}/finance-pending`, signal).then((r) => r.items), [base]);
  const accounts = overview.accounts.filter((a) => !a.archived);
  const [account, setAccount] = useState(accounts[0]?.id ?? '');
  const [busy, setBusy] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  if (data.status !== 'ready' || data.data.length === 0) return null;
  async function record(id: string, title: string) {
    setBusy(id);
    setError(null);
    try {
      await api.post(`${base}/${id}/finance`, { accountId: account });
      data.reload();
      onChange(`Gasto de mantenimiento «${title}» registrado.`);
    } catch (e) {
      setError(errorMessage(e));
    } finally {
      setBusy(null);
    }
  }
  return (
    <Card title="Gastos de mantenimiento por registrar">
      <p className="muted small">Trabajos terminados con costo real. Elige de qué cuenta salió el dinero y regístralo.</p>
      {error ? <Alert>{error}</Alert> : null}
      <div className="field">
        <label htmlFor="mt-account">Cuenta</label>
        <select id="mt-account" value={account} onChange={(e) => setAccount(e.target.value)}>
          {accounts.map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}
        </select>
      </div>
      <ul className="list">
        {data.data.map((m) => (
          <li key={m.id} className="list__item">
            <span><Link to={`/app/mantenimiento/${m.id}`}>{m.title}</Link> · <strong>{formatMoney(m.actualCostCents, 'MXN')}</strong></span>
            <Button variant="secondary" busy={busy === m.id} disabled={!account} onClick={() => void record(m.id, m.title)}>Registrar gasto</Button>
          </li>
        ))}
      </ul>
    </Card>
  );
}
